// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidebar-container{
    width: 286px;
    height: 1160px;
    background-color: white !important;

  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}

.logo-container1 span{
    font-size: 28px;
    font-weight: bold;
  
}

a{
    text-decoration: none;
    color: black;
}

.sidebar-itemm{
    font-weight: bold;
  
}


.sidebar-itemm img ,.sidebar-itemm svg{
  filter: brightness(0.8) contrast(1.9) saturate(0);
}

.sidebar-itemm.active img ,.sidebar-itemm.active svg{
filter:none
}

.sidebar-itemm.active {
    color: rgba(43, 167, 105, 1) !important; 
    font-weight: bold;
    
}

/* .sidebar-itemm.active::before{
  content: "";
  background-color:rgba(43, 167, 105, 1) !important;
  position: absolute;
  top:-10px;
  right:-65px;
  width: 10px;
  height: 50px;
  border-radius: 20px;
}  */

`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,cAAc;IACd,kCAAkC;;EAEpC,wCAAwC;AAC1C;;AAEA;IACI,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,iBAAiB;;AAErB;;;AAGA;EACE,iDAAiD;AACnD;;AAEA;AACA;AACA;;AAEA;IACI,uCAAuC;IACvC,iBAAiB;;AAErB;;AAEA;;;;;;;;;IASI","sourcesContent":["\n.sidebar-container{\n    width: 286px;\n    height: 1160px;\n    background-color: white !important;\n\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);\n}\n\n.logo-container1 span{\n    font-size: 28px;\n    font-weight: bold;\n  \n}\n\na{\n    text-decoration: none;\n    color: black;\n}\n\n.sidebar-itemm{\n    font-weight: bold;\n  \n}\n\n\n.sidebar-itemm img ,.sidebar-itemm svg{\n  filter: brightness(0.8) contrast(1.9) saturate(0);\n}\n\n.sidebar-itemm.active img ,.sidebar-itemm.active svg{\nfilter:none\n}\n\n.sidebar-itemm.active {\n    color: rgba(43, 167, 105, 1) !important; \n    font-weight: bold;\n    \n}\n\n/* .sidebar-itemm.active::before{\n  content: \"\";\n  background-color:rgba(43, 167, 105, 1) !important;\n  position: absolute;\n  top:-10px;\n  right:-65px;\n  width: 10px;\n  height: 50px;\n  border-radius: 20px;\n}  */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
